/**
 * @desc 根据店铺查询仓库
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.warehouse.getWarehouseByShop.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouse/getWarehouseByShop`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
